import { render, staticRenderFns } from "./faxian.vue?vue&type=template&id=c9a5f340&scoped=true"
import script from "./faxian.vue?vue&type=script&lang=js"
export * from "./faxian.vue?vue&type=script&lang=js"
import style0 from "./faxian.vue?vue&type=style&index=0&id=c9a5f340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a5f340",
  null
  
)

export default component.exports